import { render, staticRenderFns } from "./MegaMenu.vue?vue&type=template&id=1d67a0d2&v-if=menu.length%20%7C%7C%20menu_showcase.length&"
import script from "./MegaMenu.vue?vue&type=script&lang=js&"
export * from "./MegaMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports